// Configuration settings for the checkout app
export const INTEGRATION_SERVER_URL =
  process.env.REACT_APP_INTEGRATIONS_SERVER_URL ||
  (process.env.REACT_APP_MODE === "production"
    ? "https://backend.aisensy.com/apps"
    : process.env.REACT_APP_MODE === "staging"
      ? "https://backend.aisensy.com/stg/apps"
      : process.env.REACT_APP_MODE === "prestaging"
        ? "https://backend.aisensy.org/apps"
        : "http://localhost:5006/apps");

export const CHECKOUT_PREFIX =
  process.env.REACT_APP_MODE === "production"
    ? "https://checkout.aisensy.com"
    : process.env.REACT_APP_MODE === "staging"
      ? "https://staging.dw96ydrzcuv97.amplifyapp.com"
      : process.env.REACT_APP_MODE === "prestaging"
        ? "https://pre-staging.d1r1s4fhnn0nv9.amplifyapp.com"
        : "http://localhost:3000";

export const LogRocketEnv = "evolve-05ecg/ev";

export const EVENT_SERVER_URL =
  process.env.REACT_APP_EVENT_SERVER_URL || "http://localhost:5006";

export const SIGNUP_SCRIPT_URL =
  process.env.REACT_APP_SIGNUP_SCRIPT_URL ||
  "https://d2jyl60qlhb39o.cloudfront.net/system/aisensy_signup_script_v1.3.js";
